import script from "./AppSidebarEntity.vue?vue&type=script&setup=true&lang=js"
export * from "./AppSidebarEntity.vue?vue&type=script&setup=true&lang=js"

import "./AppSidebarEntity.vue?vue&type=style&index=0&id=433fc9ed&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-433fc9ed"]])

export default __exports__